/**
 * main.jsx
 * 
 * Punto de entrada principal de la aplicación React
 * 
 * Qué hace:
 * - Renderiza el componente App en el elemento root del HTML
 * - Configura React para trabajar con el DOM
 * 
 * Dónde modificarlo:
 * - Solo si necesitas agregar providers globales (Context, Router, etc.)
 */

import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './styles/index.css'

// Obtiene el elemento root del HTML donde se montará React
const rootElement = document.getElementById('root')

// Crea la raíz de React y renderiza la aplicación
ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)

